import { AttributeTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { AttributeType } from '@/services/graphql/types';

export const mapperAttributeTypeDataEnum = createEnumMapperFunction(
  AttributeType,
  AttributeTypeDataEnum
);
